import { SvgReplyLeft, TextButton } from '@loomhq/lens';
import React, { Component } from 'react';

class UndoButton extends Component {
  render() {
    const { currentTrimRange, undoStack } = this.props;

    const canUndo = currentTrimRange == null && undoStack.length > 0;

    const undoOnClick = canUndo ? this.props.onUndoTrim : null;

    return (
      <TextButton
        icon={<SvgReplyLeft />}
        isDisabled={!canUndo}
        onClick={undoOnClick}
      >
        Undo
      </TextButton>
    );
  }
}

export default UndoButton;
